import { createReducer, on } from "@ngrx/store";
import {
  fetchCategories,
  fetchCategoriesSuccess,
  fetchCategoriesFailure,
  setActiveCategory,
} from "./category.actions";

import { IState } from "@models/index";

const initialState: IState = {
  isLoaded: false,
  data: [],
  filteredDate: [],
  selectedItem: {},
  error: null,
  total: 0,
  maxPages: 0,
  perPage: 0,
  currentPage: 0,
};

const _categoryReducer = createReducer(
  initialState,
  on(fetchCategories, (state, { page, filterOptions }) => {
    return state;
  }),
  on(fetchCategoriesSuccess, (state, { category }) => {
    const payload = {
      isLoaded: true,
      data: category.data,
      total: category.total,
      maxPages: category.maxPages,
      perPage: category.perPage,
      currentPage: category.currentPage,
      selectedItem: {},
    };

    return { ...state, ...payload };
  }),
  on(fetchCategoriesFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error,
    };
    return { ...state, ...payload };
  }),
  on(setActiveCategory, (state, { item: selectedItem }) => ({
    ...state,
    selectedItem,
  }))
);

export function categoryReducer(state, action) {
  return _categoryReducer(state, action);
}
